export default __webpack_public_path__ + "static/media/111room.be9f5fe5.jpeg";